module.exports = "/images/callToDeliveryMan.svg";